export default {
  /* eslint-disable no-param-reassign */
  /* eslint-disable no-unused-expressions */
  collectors: state => state.collectors,
  navigation: state => state.navigation,
};



// WEBPACK FOOTER //
// ./src/store/modules/collectors/getters.js